import { createSelector } from '@ngrx/store';
import { IsAnnouncementPinnedPipe } from '../../shared/pipes';
import { State as AppState } from '../reducers/index';
import { AnnouncementsState } from './announcements.reducer';
import { isBefore, parseISO } from 'date-fns';

export const getAnnouncementsState = (state: AppState) => state.announcements;

// Returns only the pinned announcements that have not expired.
// Sorted reverse chronologically.
export const getPinnedAnnouncements = createSelector(
  getAnnouncementsState,
  (state: AnnouncementsState) => {
    return state.ids
      .filter((id) => new IsAnnouncementPinnedPipe().transform(state.entities[id]))
      .map((id) => state.entities[id])
      .sort((a, b) => {
        if (a == b) {
          return 0;
        }
        return isBefore(parseISO(a.created), parseISO(b.created)) ? 1 : -1;
      });
  }
);

export const getAnnouncementHistoryEntities = createSelector(
  getAnnouncementsState,
  (state: AnnouncementsState) => {
    if (state && state.history) {
      return state.history.entities;
    }
    return {};
  }
);

export const getAnnouncementHistoryLoading = createSelector(
  getAnnouncementsState,
  (state: AnnouncementsState) => {
    if (state && state.history) {
      return state.history.loading;
    }
    return false;
  }
);
